import styled, {css} from 'styled-components'

export const StyledBudgetAccessRates = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        & > *:first-child {
            padding: ${spacing * 4}px ${spacing * 6}px;
        }
    `
)

export const StyledBudgetAccessRatesContent = styled.div(
    ({theme: {spacing}}) => css`
        overflow-y: auto;
        display: flex;
        width: 100%;
        flex-direction: column;
        padding: ${spacing * 4}px ${spacing * 6}px;
        gap: ${spacing * 4}px;
    `
)
